import { images } from "../constants";

const awards = [
    images.award1,
    images.award2,
    images.award3,
    images.award4,
    images.award5,
    images.award6,
];

export default awards;